import { Env, readFromEnv } from '@cinch-nx/environments'

const isAndroidUserAgent = (userAgent: string) => /android/i.test(userAgent)

export const getAppStoreUrl = (userAgent = ''): string => {
  if (isAndroidUserAgent(userAgent)) {
    return readFromEnv(Env.AndroidAppStoreUrl)
  }

  return readFromEnv(Env.IOSAppStoreUrl)
}
